<!--suppress ALL -->
<template>
	<div id="projects-index"
		 class="app-home ui-styles"
		 :class="theme">

		<template class="view_container">

			<div class="loading_view" v-if="master_loading">
				<div class="view_spinner_container">
					<span style="color: rgb(0, 79, 146); margin: 0 auto;">
					<icon name="spinner" scale="4"
						  color="rgb(0, 79, 146)" spin></icon></span><br>
					<span>{{ $t('Loading')}}...</span>
				</div>
			</div>

			<div class="master_view">
				<side-nav-bar :filesOpen="filesOpen" :fileOpen="fileOpen" :realEstateId="realestate.id"></side-nav-bar>

				<div class="app-container">
					<bar>
					</bar>
					<h1>{{ $t('Project') }} {{ $t('with') }} {{ $t('date')
						}} {{ project.projectdate}} {{$t('at')}} <span
								v-if="realestate.street_name">{{ realestate.street_name
							}}</span><span
								v-if="realestate.street_number">, {{ realestate.street_number }}</span><span
								v-if="realestate.floor">, {{ realestate.floor}}</span><span
								v-if="realestate.door"> {{ realestate.door }}</span> <span
								v-if="project.dirty">*</span>
					</h1>
					<message
							v-if="project.dirty"
							:text="page_dirty_text" icon_name="info" icon_color="rgb(0, 135, 248)"
							border_color="rgb(0, 135, 248)" text_color="rgb(0, 135, 248)">
					</message>
					<div class="datedata">
						<p class="small">{{ $t('Created') }}: {{ millis_to_time(project.date_created) }}</p>
						<p class="small">{{ $t('Last_modified') }}: {{ millis_to_time(project.date_modified) }}</p>
					</div>

					<vue-tabs v-model="tabName">
						<v-tab :title="General_data_text">
							<div v-if="currentLocale === 'ca'" slot="title"
								 @click.prevent="setCurrentTabTitle('Dades generals')">{{General_data_text}}
							</div>
							<div v-else-if="currentLocale === 'en'" slot="title"
								 @click.prevent="setCurrentTabTitle('General data')">{{General_data_text}}
							</div>
							<div v-else slot="title" @click.prevent="setCurrentTabTitle('Datos generales')">{{General_data_text}}</div>
							<div class="tab_content">
								<div>
									<form class="bt-form">
										<div class="section-container">
											<h3>{{ $t('Project_type') }}</h3>
											<div class="field-container">
												<!--
												<div class="ms-container">
													<label class="field__group__label">{{ $t('Project_type')
														}}</label>
													<multiselect placeholder=""
																 :value="projectTypeValue"
																 :options="projectTypeOptions"
																 track-by="id"
																 :label="(currentLocale === 'ca')?
											 'name_ca': (currentLocale === 'en')?
											 'name_en': 'name_es'"
																 :searchable="false"
																 v-model="project.type"
																 @input="set_project_type"></multiselect>
												</div>
												-->

											</div>
										</div>


									</form>
								</div>
							</div>

						</v-tab>
						

						<v-tab :title="metadata_text">
							<div v-if="currentLocale === 'ca'" slot="title"
								 @click.prevent="setCurrentTabTitle('Metadades')">{{metadata_text}}
							</div>
							<div v-else-if="currentLocale === 'en'" slot="title"
								 @click.prevent="setCurrentTabTitle('Metadatos')">{{metadata_text}}
							</div>
							<div v-else slot="title" @click.prevent="setCurrentTabTitle('Metadata')">{{metadata_text}}
							</div>
							<div class="tab_content">
								<div>
									<form class="bt-form">
										<div class="section-container">
											<h3>{{ $t('Description') }}</h3>

											<div class="field-container">
												<!--
												<div class="field__group">
													<label class="field__group__label">{{ $t('Project_description')
														}}</label>
													<input class="field__group__input"
														   type="text"
														   spellcheck="false"
														   v-model="project.description"
														   @input="set_project_description">
												</div>
												-->
											</div>
										</div>
									</form>
								</div>
							</div>
						</v-tab>
					</vue-tabs>

					<!--
					<div>
						<div @click.prevent="setCurrentTab('Metadades')"
							 style="width: fit-content; margin-left: auto">
							<icon-button icon="floppy-o" text="provar canvi de tab" icon_color="white"
										 text_color="white" border_color="#006bc5"
										 background_color="#0087F8"></icon-button>
						</div>
					</div>
					-->
					<div>
						<div @click.prevent="onGoUp" style="width: fit-content; margin-left: auto">
							<icon-button icon="level-up" :text="goup_button_text"
										 icon_color="black"
										 text_color="black" border_color="lightgray"></icon-button>
						</div>
					</div>
					<div>
						<div @click.prevent="onSaveCurrentProject({go_up: false})"
							 style="width: fit-content; margin-left: auto">
							<icon-button icon="floppy-o" :text="save_button_text" icon_color="white"
										 text_color="white" border_color="#006bc5"
										 background_color="#0087F8"></icon-button>
						</div>
					</div>
					<div>
						<div @click.prevent="onSaveCurrentProject({go_up: true})"
							 style="width: fit-content; margin-left: auto">
							<icon-button icon="floppy-o" :text="save_and_go_up_button_text" icon_color="white"
										 text_color="white" border_color="#006bc5"
										 background_color="#0087F8"></icon-button>
						</div>
					</div>
					<message
							v-if="project.dirty"
							:text="page_dirty_text" icon_name="info" icon_color="rgb(0, 135, 248)"
							border_color="rgb(0, 135, 248)" text_color="rgb(0, 135, 248)">
					</message>


					<!--
					<bar>
					</bar>
-->
				</div>
			</div>

		</template>
	</div>
</template>

<script>
    import { mapActions, mapGetters, mapMutations } from 'vuex'
    import Vue from 'vue'
    import _ from 'lodash'
    import moment from 'moment'
    import {
        dateMixin,
        localStorageMixin,
        mathMixin,
        objectsMixin,
        typeCheckMixin
    } from '../../../mixins'
    import Spinner from '../../../components/Spinner.vue'
    import Search from '../../../components/ContactsSearch/Index.vue'
    import Editor from '../../../components/Editor/Index.vue'
    import Bar from '../../../components/Bar/Index.vue'
    import IconButton from '../../../components/IconButton/Index.vue'
    import SideNavBar from '../../../components/SideNavBar/Index.vue'

    import router from '../../../router/index.js'

    import Message from '../../../components/Message.vue'

    import projectTypeOptions from '../../../options/project_types'
    import countryOptions from '../../../options/countries'
    import spanishProvinceOptions from '../../../options/spanish_provinces'
    import property_typeOptions from '../../../options/property_types'
    import conservation_statusOptions from '../../../options/conservation_statuses'
    import room_typeOptions from '../../../options/room_types'
    import covered_outdoor_typeOptions from '../../../options/covered_outdoor_types'
    import uncovered_outdoor_typeOptions from '../../../options/uncovered_outdoor_types'
    import selected_areaOptions from '../../../options/selected_areas'
    import plot_occupationOptions from '../../../options/plot_occupations'
    import plot_free_area_usageOptions from '../../../options/plot_free_area_usages'

    import construction_statusOptions from '../../../options/construction_statuses'

    import Datatable from '../../../components/Datatable/datatable.vue'
    import DatatableColumn from '../../../components/Datatable/datatable-column.vue'
    import aggregators from '../../../aggregators/aggregators.js'
    import formatters from '../../../formatters/formatters.js'
    import Checkbox from '../../../components/Toggles/checkbox.vue'
    import Paginator from '../../../components/Paginator/paginator.vue'

    import occupancy_statusOptions from '../../../options/occupancy_statuses'

    let fonts = {
        Roboto: {
            normal: 'fonts/Roboto-Regular.ttf',
            bold: 'fonts/Roboto-Medium.ttf',
            italics: 'fonts/Roboto-Italic.ttf',
            bolditalics: 'fonts/Roboto-MediumItalic.ttf'
        }
    }

    export default {
        name: 'project-editor',

        mixins: [
            dateMixin,
            localStorageMixin,
            mathMixin,
            objectsMixin,
            typeCheckMixin
        ],

        data: () => ({
            tabName: '',
            currentTabTitle: '',
            master_loading: true,
            urban_map_offset: 5,
            urban_map_size: '640x480',
            urban_map_width: 640,
            urban_map_height: 480,
            urban_map_zoom_factor: 0.1,
            editing_room: false,
            editing_room_text_color: 'black',
            editing_room_border_color: 'lightgray',
            editing_covered_outdoor: false,
            editing_covered_outdoor_text_color: 'black',
            editing_covered_outdoor_border_color: 'lightgray',
            editing_uncovered_outdoor: false,
            editing_uncovered_outdoor_text_color: 'black',
            editing_uncovered_outdoor_border_color: 'lightgray',
            creatingCoveredOutdoor: false,
            creatingUncoveredOutdoor: false,
            loadingProjectPurpose: false,
            filesOpen: true,
            fileOpen: true,
            reportOpen: true,
            editabletrue: true,
            cadaster_ref_loading: false,
            idescat_info_loading: false,
            muc_info_loading: false,
            muc_map_01_loading: false,
            muc_map_02_loading: false,
            muc_map_03_loading: false,
            google_geocode_loading: false,
            error: null,
            success_message: null,
            metadata_text: Vue.i18n.translate('Version'),
            filter_placeholder: Vue.i18n.translate('Type_here_to_filter_paginated_data'),
            General_data_text: Vue.i18n.translate('General_data'),
            cancel_button_text: Vue.i18n.translate('Cancel'),
            goback_button_text: Vue.i18n.translate('Go_back') + ' ' + Vue.i18n.translate('without_saving'),
            goup_button_text: Vue.i18n.translate('Go_up') + ' ' + Vue.i18n.translate('without_saving'),
            save_button_text: Vue.i18n.translate('Save'),
            save_and_go_up_button_text: Vue.i18n.translate('Save') + ' ' + Vue.i18n.translate('and') + ' ' + Vue.i18n.translate('go_up'),
            page_dirty_text: Vue.i18n.translate('The_page_contains_unsaved_changes'),
            actions_text: Vue.i18n.translate('Actions'),
            duplicate_text: Vue.i18n.translate('Duplicate'),
            edit_text: Vue.i18n.translate('Edit'),
            delete_text: Vue.i18n.translate('Delete'),
            projectTypeValue: null,
            projectTypeOptions,
            countryOptions,
            spanishProvinceOptions,
            conservation_statusOptions,
            construction_statusOptions,
            countryValue: null,
            municipalityValue: null,
            provinceValue: null,
            property_typeValue: null,
            construction_statusValue: null,


        }),

        created () {
            this.master_loading = false

        },

        components: {
            Bar,
            Message,
            IconButton,
            Spinner,
            Checkbox,
            Datatable,
            DatatableColumn,
            Paginator,
            SideNavBar
        },

        computed: {
            ...mapGetters([
                'theme',
                'tags_display',
                'project',
                'currentLocale',
                'realestate',
                'realestate_projects',
            ])
        },

        methods: {
            ...mapActions(
                [
                    'RESET_PROJECT',
                    'UPDATE_PROJECT',
                ]),

            onSaveCurrentProject: function (data) {

                /*

                this.UPDATE_PROJECT({
                    key: this.project.id,
                    object: this.project,
                    parent_path: 'realestates/' + this.realestate.id + '/' + 'projects' + '/',
                    path: this.project.path + this.project.id,
                    realestate_id: this.realestate.id
                }).then((res) => {
                    if (data.go_up) {
                        this.onGoUp()
                    } else {
                        this.setCurrentTab(this.currentTabTitle)
                        window.scroll(0, 0)
                    }
                })

                this.UPDATE_REALESTATE({
                    key: this.realestate.id,
                    object: this.realestate,
                    // parent_path: 'projectreports/' + this.projectreport.id + '/' + 'realestates' + '/',
                    path: this.realestate.path + this.realestate.id,
                    file_id: this.projectfile.id,
                    report_id: this.projectreport.id
                }).then((res) => {

                })
                */
            },
            setCurrentTabTitle: function (tabTitle) {
                console.log('hey, current Tab Title: ' + tabTitle)
                this.currentTabTitle = tabTitle
            },
            setCurrentTab: function (tabTitle) {
                console.log('hey, current Tab: ' + tabTitle)
                this.tabName = tabTitle
            },
            onGoBack: function () {
                // console.log('yeah back')
                router.go(-1)
            },
            onGoUp: function () {
                // console.log('yeah up')
                this.$router.push({name: 'realestate-editor', query: {id: this.realestate.id}})
            },
            onCancelAll: function () {
                const result = window.confirm(Vue.i18n.translate('Changes_will_be_lost_p_continue_q'))

                if (result) {
                    router.go(-1)
                } else {
                    return false

                }
            },
        },
        head: {
            title: {
                //inner: Vue.i18n.translate('New_contact')
                inner: 'Edit project'
            }
        }

    }
</script>


// WEBPACK FOOTER //
// ProjectEditor.vue?f4266134